module.exports = __webpack_public_path__ + "img/cashier_white.01cca986.png";